import { render, staticRenderFns } from "./PainelConvidadoEdicao.vue?vue&type=template&id=72e883e3&scoped=true"
import script from "./PainelConvidadoEdicao.vue?vue&type=script&lang=js"
export * from "./PainelConvidadoEdicao.vue?vue&type=script&lang=js"
import style0 from "./PainelConvidadoEdicao.vue?vue&type=style&index=0&id=72e883e3&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e883e3",
  null
  
)

export default component.exports